module.exports = __webpack_public_path__ + "img/1717990312321-NIB TJANG TIN MA.png.f6456af7.webp";